import { Box, Text } from "@nulogy/components";
import ThinDivider from "components/common/ThinDivider";
import OverlappingPlannedBreaks from "components/pages/schedule/helpers/OverlappingPlannedBreaks";
import DowntimeBlock from "domain/DowntimeBlock";
import React from "react";
import DateTime from "utils/DateTime";
import BlockTooltip from "./BlockTooltip";
import Break from "./images/break.svg?react";

export default function DowntimeBlockTooltip({ downtimeBlock, startDate, endDate, line }) {
  const isInFuture = DateTime.isInTheFuture(endDate);
  const overlappingPlannedBreaks = isInFuture
    ? OverlappingPlannedBreaks.calculateOverlappingPlannedBreaks(line, startDate, endDate)
    : downtimeBlock.overlappingPlannedBreaks;
  const reasonDescription = DowntimeBlock.reasonDescription(downtimeBlock);

  return (
    <Box className="b-sch-event-tooltip spec-downtime-tooltip" lineHeight={0}>
      <Text data-testid="reason" fontSize="small" fontWeight="medium" lineHeight="smallTextCompressed" mb="x1">
        {reasonDescription}
      </Text>
      <BlockTooltip endDate={endDate} overlappingPlannedBreaks={overlappingPlannedBreaks} startDate={startDate} />
      {overlappingPlannedBreaks.length > 0 && (
        <>
          <ThinDivider />
          <Break />
        </>
      )}
    </Box>
  );
}
